import type { MenuItem } from '@/types';

/**
 * Android docs menu
 */
export const androidDocs: MenuItem[] = [
  { label: 'Overview', path: '/sdk_ref/android/overview' },
  {
    label: 'Express API',
    path: '/sdk_ref/android/express',
    openNested: true,
    submenu: [
      { label: 'Channel', path: '/sdk_ref/android/express-channel' },
      { label: 'Room', path: '/sdk_ref/android/express-room' },
      { label: 'PCast™', path: '/sdk_ref/android/express-pcast' },
    ],
  },
  {
    label: 'Low-Level API',
    path: '/sdk_ref/android/low-level',
    openNested: true,
    submenu: [
      { label: 'Room', path: '/sdk_ref/android/sdk-room' },
      { label: 'Chat', path: '/sdk_ref/android/chat' },
      { label: 'PCast™', path: '/sdk_ref/android/sdk-pcast' },
    ],
  },
  { label: 'Examples', path: '/sdk_ref/android/examples' },
  { label: 'Release Notes', path: '/sdk_ref/android/release-notes' },
];
